<ng-template #rightPanel>
  <ng-content></ng-content>
</ng-template>
